export default __webpack_public_path__ + "static/media/paytm.595f9c43.webp";